import { v4 } from 'uuid';

export const polyfillCryptoRandomUUID = () => {
  if (typeof window.crypto.randomUUID === 'undefined') {
    // @ts-ignore ignored
    window.crypto.randomUUID = () => v4();
  }
};
